<script lang="ts">
	import { appState } from '$lib/appstate.svelte.js';
	import { MAIN_TABS } from '$lib/constants';
	import { onMount } from 'svelte';
	import { goto } from '$app/navigation';
	import ClearableInput from '$lib/components/ClearableInput.svelte';
	import { showBusy, hideBusy } from '$lib/busy.svelte';

	let { children } = $props();
	let invalidText = $state('');

	//display blank if no verb is set, otherwise display the full verb name with accent marks
	let verb = $derived.by(() => {
		return appState.verb?.verbName ?? '';
	});

	onMount(() => {
		appState.mainTab = MAIN_TABS.HOME;
	});

	async function handleSubmit(e: SubmitEvent) {
		e.preventDefault();
		if (verb === '') {
			return;
		}
		if (appState.verb && appState.verb.searchName === verb) {
			//if verb hasn't changed then don't do search
			return;
		}

		showBusy();
		await goto(`/${verb}/conjugation`);

		hideBusy();

		invalidText = '';
	}
</script>

<form onsubmit={handleSubmit} class="flex flex-col items-start space-y-4">
	<ClearableInput
		type="text"
		placeholder="enter french verb"
		autocapitalize="off"
		spellcheck="false"
		autocomplete="off"
		autocorrect="off"
		maxlength="20"
		error={invalidText}
		name="search"
		bind:value={verb}
	/>
	<button type="submit" class="btn-primary"> Search </button>
</form>

<div id="tabs">
	{@render children?.()}
</div>
